import React from 'react';
import { Step } from 'react-joyride';
import i18n from '../../../translation/i18n';
import { StepTextContent } from '../../../components/app/onboarding/steps/step-text-content';

// Useful arguments:
//
// spotlightClicks - clickable target
// hideFooter - hide buttons
// disableOverlay
// hideCloseButton
// disableScrolling
// showSkipButton

export const addTradesManualSteps: Step[] = [
    {
        target: '#add-trade-button',
        disableBeacon: true,
        disableOverlayClose: true,
        disableScrolling: true,
        spotlightClicks: false,
        hideBackButton: false,
        showSkipButton: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.manual.step01', { returnObjects: true })} />
        ),
    },
    {
        target: '#create-trade-symbol',
        placement: 'bottom',
        disableBeacon: true,
        disableOverlayClose: true,
        disableScrolling: true,
        hideBackButton: false,
        showSkipButton: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.manual.step02', { returnObjects: true })} />
        ),
    },
    {
        target: '#create-trade-date',
        placement: 'bottom',
        disableBeacon: true,
        disableOverlayClose: true,
        disableScrolling: true,
        hideBackButton: false,
        showSkipButton: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.manual.step03', { returnObjects: true })} />
        ),
    },
    {
        target: '#create-trade-currency',
        placement: 'bottom',
        disableBeacon: true,
        disableOverlayClose: true,
        disableScrolling: true,
        hideBackButton: false,
        showSkipButton: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.manual.step04', { returnObjects: true })} />
        ),
    },
    {
        target: '#create-trade-broker',
        placement: 'bottom',
        disableBeacon: true,
        disableOverlayClose: true,
        disableScrolling: true,
        hideBackButton: false,
        showSkipButton: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.manual.step05', { returnObjects: true })} />
        ),
    },
    {
        target: '#create-trade-form-submit',
        placement: 'top',
        disableBeacon: true,
        disableOverlayClose: true,
        disableScrolling: true,
        hideBackButton: false,
        hideFooter: false,
        spotlightClicks: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.manual.step06', { returnObjects: true })} />
        ),
    },
    {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        disableOverlayClose: true,
        hideBackButton: false,
        hideFooter: false,
        spotlightClicks: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.manual.step07', { returnObjects: true })} />
        ),
    },
    {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        disableOverlayClose: true,
        hideBackButton: false,
        hideFooter: false,
        showSkipButton: false,
        content: (
            <StepTextContent content={i18n.t('layout.onboarding.addTrades.manual.step08', { returnObjects: true })} />
        ),
    },
];
